angular.module('mychart').controller('LabResultPrintDownloadModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', '$window', 'PersonRepository', 'attachmentInfo',
        function ($scope, $modalInstance, $sce, $window, PersonRepository, attachmentInfo) {
            'use strict';

            var imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'rtf', 'doc', 'docx', 'tif', 'tiff'];
            var htmlFormats = ['html', 'htm'];
            var textFormats = ['txt'];

            $scope.attachmentInfo = attachmentInfo;

            $scope.loadingLabResult = true;
            $scope.displayPrintButton = false;

            $scope.model = {
                LabResultData: '',
                PdfFileName: attachmentInfo.ActivePatient.firstName + attachmentInfo.ActivePatient.lastName + '_TestResult.pdf',
                ByteArray: '',
                ContentType: ''
            };

            function loadResult() {
                $scope.loadingLabResult = true;
                $scope.removeHttpError();

                $scope.isImage = _.includes(imageFormats, attachmentInfo.Extension.toLowerCase());
                $scope.isHtml = _.includes(htmlFormats, attachmentInfo.Extension.toLowerCase());
                $scope.isText = _.includes(textFormats, attachmentInfo.Extension.toLowerCase());

                if (!$scope.isImage && !$scope.isHtml && !$scope.isText)
                {
                    $scope.loadingLabResult = false;
                    return;
                }

                PersonRepository.getAttachmentPdf(attachmentInfo.ActivePatient.id,  attachmentInfo.AttachmentUid)
                    .then(function (data) {
                        var labResultUrl = 'data:' + data.ContentType + ';base64,' + data.ByteArray;
                        $scope.model.LabResultData = $sce.trustAsResourceUrl(labResultUrl);
                        $scope.model.ByteArray = data.ByteArray;
                        $scope.model.ContentType = data.ContentType;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function() {
                        $scope.loadingLabResult = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }


            $scope.ok = ok;
            $scope.cancel = cancel;
            $scope.print = print;

            loadResult();
        }]);